import React, { Fragment } from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

const Surcharge = ({
    locationSurcharges = [],
    allSurcharges = [],
    removeSurcharge,
    selectedSurchargeId,
    surchageSelection,
    onSurchargeAdded,
    selectedLocationId,
    t,
    selectableSurcharges,
}) => {
    if (!allSurcharges || !allSurcharges.length) return <></>;

    return (
        <Fragment>
            <div className="row products__taxes-row">
                {locationSurcharges.map(surcharge => {
                    const surchargeData = allSurcharges.find(s => s.id === surcharge.id);
                    return (
                        <Fragment key={surcharge.id}>
                            <FormGroup className="col-lg-1">
                                <Input type="text" disabled value={`${surcharge.order}.`} />
                            </FormGroup>
                            <FormGroup className="col-lg-5">
                                <Input type="text" disabled value={surchargeData.name} />
                            </FormGroup>
                            <FormGroup className="col-lg-3">
                                <Input disabled type="text" value={surchargeData.value} />
                            </FormGroup>
                            <FormGroup className="col-lg-2">
                                <Input type="text" value={surchargeData.valueType === 1 ? '%' : 'Fixed amount'} disabled />
                            </FormGroup>

                            <FormGroup className="col-lg-1 products__prices-btn">
                                <Label></Label>
                                <button type="button" onClick={() => removeSurcharge(null, surchargeData.id)}>
                                    <i className="fas fa-trash"></i>
                                </button>
                            </FormGroup>
                        </Fragment>
                    );
                })}
            </div>
            {/*
            <div className="row">
                <div className="col">
                    <hr />
                </div>
            </div>*/}
            <div className="row products__taxes-row">
                <FormGroup className="col-md-9">
                    <Label for="tax">{}</Label>
                    <Input
                        type="select"
                        id="tax"
                        value={selectedSurchargeId || ''}
                        onChange={e => {
                            if (!e.target.value) {
                                surchageSelection(null);
                            } else {
                                surchageSelection(e.target.value);
                            }
                        }}
                    >
                        <option value={0}>{t('surcharge:select')}</option>
                        {(selectableSurcharges || []).map(surcharge => (
                            <option value={surcharge.id} key={`selection-${surcharge.id}`}>
                                {surcharge.name}
                            </option>
                        ))}
                    </Input>
                </FormGroup>
                <FormGroup className="col-md-3">
                    <Label>{}</Label>
                    <button className="products__prices-add" type="button" onClick={() => onSurchargeAdded(selectedLocationId)} disabled={!selectedSurchargeId}>
                        {t('addNew')}
                    </button>
                </FormGroup>
            </div>
        </Fragment>
    );
};

export default Surcharge;
